import React, { Component } from "react";

import HSGLogo from "./../Assets/hsg-logo.png";
import Source from "../../source";

class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div ref="auth-footer" className="container-fluid hsg-auth-footer-root">
                <div className="col-xs-12">
                    <div className="col-xs-6 col-sm-8">
                        <div className="col-xs-12 right">
                            {Source.STRING_FOOTER_NUMBER}
                            {Source.STRING_FOOTER_NUMBER}
                        </div>
                    </div>
                    <div className="col-xs-6 col-sm-4 center">
                        {Source.STRING_FOOTER_COPYRIGHT}
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;
